import { Columns } from '@shared/interfaces/table/column-config';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';

/**
 * Resolution Partial Translation Cell
 * Translates relevant resolution enums into strings
 */
export const resolutionPartial: Columns<any> = {
  title: 'table.resolution.title',
  key: 'resolutionDuration',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    'notspecified': 'enum.resolution.notspecified',
    'year': 'enum.resolution.year',
    'month': 'enum.resolution.month',
    'day': 'enum.resolution.day',
    'hour': 'enum.resolution.hour',
    'quarter': 'enum.resolution.quarter',
  }
}
